import React from "react";
import InputBox from "./InputBox";
import { resetpassword } from "../../utils/firebase/Firebase.utils";

import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");

  const handleResetPassword = (e) => {
    e.preventDefault();

    const reset = async () => {
      try {
        const res = await resetpassword(email);

        if (res) {
          alert("Check your email for password reset link");
          navigate("/login");
        } else {
          alert("Error: Please try again");
        }
      } catch (error) {}
    };
    reset();
  };

  const handleChange = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
  };

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center px-4 py-2">
      <div className="border border-solid px-4 py-2 rounded-xl ">
        <h1 className="text-3xl font-bold">Reset Password</h1>
        <p>
          Enter your email address and we will send you a link to reset your
          password.
        </p>
        <form action="" onSubmit={handleResetPassword}>
          <InputBox
            type="email"
            placeholder="Email Address"
            onChange={handleChange}
          />
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded mt-4 w-60"
            type="submit"
          >
            Send Reset Link
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
